import bus from '@/util/useBus'
import { t } from '@/plugins/i18n'

// 放大镜
const icon1 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAkCAYAAADsHujfAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIqADAAQAAAABAAAAJAAAAACNOlT0AAAEqklEQVRYCc2XXWibVRjHk7dNE7C1OpRt7S7asqHijVubJkE2O5RC/NqmFi+neKFML1RwCgpW8QMVLyZMcMguvFGs4pCmEUStjq7fDNyYX6wdrppRvwrpdJom8ffEnJfnPc3apMnAA4fzfD//8/Ge87w+3/+k+SvB0dnZuRH72+hb6Rv9fv+GfD7vMJ6DTzGeyOVyg9PT0z/CV9RWBdLX11c3Ozu7l4T7iLyNvqoPNicAdai9vf3QwMDAP+UgWjFoV1fX3QR5ERDXlBOshM0ZAD07NTX1TgmdR1QSCFsQIMAbAHjIY71GhljvBgKBB0ZHR/+6WIhlQABxFY4fAmKH7YQ8i/wY8qG6urrvGM9ls9kccjkrm+FvpW+nB+h2m25oaNgFmJ9shfAeIJyHBs7DMEFjlnEG/u1QKPTCyMjIz5bOw8pEEDwFuIeJE9JKZCcbGxtjw8PDi1outAcIZ+IwzvdrI5y/r6+v3z02NvaNlq9GR6PRtqWlpY+Id4Nle4Qzcxdx81ruGCYcDt9XAsRnzCBSKQiJic8Z4t0IecTkKI67mfDjluy/Fenp6QktLi7+gOMmZXCKrYiyFWklq5iMx+PB+fn5L3GMKOc/mpqaOtiiBSMrrEg6nd5ngfgTgzurBSFJksnk3wx72IrfhC+2K5n4E4aRsQAEo8e0EPoAt+NpS7ZmllgpJvqyFeARuSaMzGG/turVAFSaZXvVGNRqJOZBYstTUGjkvNxxnJsM7yCQt8Nt8J/ovXMVVRLEvEAIz8HVuWVrojoHqAc1X0uaxJ7Y8G5uASIvqttQnnSZGhPBYNCO7eZeBoRP1t3HGuPwNTc327E3mBxSSwQNIyP1hOzlJWmRSCRDvqwKHpAyQ3g5rB6UAHFRKoeakNwpV5OvkFgCAuoX6pUCMNkaDxBe0zYxuhSNt6dNx9WLIEC+tZS9mq8x7YnNiri55YwkdDL4O0DqeZW1vkp6l+Xv5nZ4XT8nuVs5AaKDl/hey6Fqlpi3EKRTBcqRK2l4R248BO8bgYzwz0uRpGXV0P39/fJR2G/NEG/QryaunBEf9WQ/g662t8zMzBwUXS1aIpF4CSBdKlaeUvMZxfsKn9Lc3NxCa2vrehTdSrmtpaUlnUqlRpWsYlIKLq6E17QjR+G9ycnJN7WssCIiAOHTDO4pLhq9zlN9gMKpvsiXPbACfnyfA8Rh7QSIsxTRj2qZ0J6vg5tvC9/6BPIrLMNxnuz9zOIrS16SZRXCAHgF5U5tAAgpkmLUrMe1XGgPEBEQ42ZmI0Vvk/BW+wJAH7B6Q1KTah2T2ETyOH576HGtU/QFfHsnJiaOKlmBXAZEpIC5nmAf0ztsB8XL4ZZb2fzXhJRuJfI8YOI2mJJAJEosFluXyWTeAsw9K0UtQyfn7lrLbhkY97Bahj7+yH5nL/tAH2ZvP7X1q/H4jOC7g7viOugnLfvLeNOS3d3d2438oitiDMzICm1mhW6Hly517jqjK44LJPwaOgGAwfHx8VNaT228Hx85wLqd58z18hEcKxuI9ha6+L+ynsvQkWKqWJPaZh6+BJjTANkJkLNrBuLJUAGjwLggKnCvrSlgHpTPXUf9F2CL5yaELdl2AAAAAElFTkSuQmCC'
// 铁锹
const icon2 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACE8iBbAAAFaElEQVRYCc2XW0hlVRjHPcejNo1Ol8EiLVKJpNuA4120sSEMk6FRkgimCGKgXpqHMHoJJILxISKC5qGXoCGaQWIePI1JUxlTOt4mehgJNNQoBrxNjTIHzUu/b3O+3drLvbfHG7RgnbW+6/rvb33rW+ukpf1PW2QvcZWWlt6H/3foFZFI5Mb6+npXUVHRx52dnaubrbtnwMrLy4+sra1dAMBdFojL0MdGRkb+tvgeck+AJUF9xUr7Pav9RwwwfSYM3K4DSwGUwgsFF1Wt3RirqqoK2L44vuxISZ79aK1RCd1DHt5h8R1yV4GtrKy8j9dsc6FoNNrGlr2Xk5PTCD9lcLsKjFN3xAY1NDQkYNN6e3sXtwJuV4FRElZMYGzrQZPeCriUgNXX18dI6hfoLe3t7YE2ROxbEwjzt8mh0yZvE3Dx1tbWdNEPXESdNTQ07F9cXLzE15+jfxmPx7saGxuzVG6NbURtzuJtBVztxMTEG2IfCkxAzc/PXzRzh/mzMzMzF/zAkeTXkTfg98YOwD0XCswA9aS1SBqLN4aAu4r+03S7svtGDj25Hczm5KVvxMJAqYcwcJSIArbUrmVi6gFH/r0Gzzm16pdxSOYbKj/Kt+O0m4U9kYI3jP4++I+JoTbRzc3Nbe7u7l4SnhwQdM7TY6rjM3bAm6KfoZsYFrOysh7v6+ubMpmOfVlZ2VmcnnCI5A+LD2VnZzesrq5mJBKJ75H7gpudnW1CZoNaw34R/gHTp898iUgfp+59LTIPMKL1Ojz5CrcpKI75X8Ksq6vLDQAnW1ACADNSAuoVeNeQXaLbLw1YTvOAEo4LrLKy8hBXijjPdFRFGIlcI1K1Ckr5NTU19ywvL3/Hgp7IqTw5OqCGh4fPCs1HH8bfN9jcberBS9BbNFIqc5OfbWqDaYK6SWhbbFBiSA5MZ2ZmHhXg6sgaPaBERim5Sv48gc15+hz9Jv0iohIblOg7ESNa9xKt36FdYIA6gcHnohTUSPSTFN1PbDkL/syBqNYDYcuFJnKoRdb9ZMJzIgaok8xdUMzHmpqavhCFoJY8fZ58VF0WLQmqc6oTBkp0dCtr1SA5fsCduGbxXDKVkgC4wCLsOgqZKLBiUyc9Pb3HpM15RUVFM4tuKAnonCIKnpzbCbhodXX1Ppw+qIvjfG5wcHBCaXMkFw9wSD5jwQ0lgeT+yO9AbBdclPySp61bNnA0boIx5+jmQpsvVM/pCzqt2wEXLSgomCFK7v885uYhMHHJkf8N+TlhMiY4uS9rnVLFzcDpe0v1g8ao/Pnki6ZVgblsbWADyIsIHwHUA0HlJAzc5OTkS4HODYGT/Hz9n8pj/hB556nOKtORyP1KHtoPQhU7I/k2z0eOeZgQ8IKuJY+qnkp5OTgNwxjXzTGltzPKU5xXr9TB45b9OFfcpxbPl1RgXaaUqJ0iFwJzzdS15wqKD3zeko3HYrGn/K44S88hHWCFhYVSt9ztxGkJb+/TfgZhPEmBhYWFeBCogYGBP8LsTZnzj2R0dHQ9Pz9f3kv1hrAqLy/vtuLi4h9I2MBbQPUpvNXUOPnAMuUlRydSWwEldm79kj8X09PTffAOJx3qMMCkg2Tu6e/vTyhTxuRrt54IvQl51JQl59sCJbYuMCG4A4t4LYwwvVNoq92Clj8at8jBJcDIu/5RRifqlq7UuZ+QtXKCr9uyVGgPMDFgSx5mSzqZHkrFgZ8OoD4E1FuA+sdPngpvAzAxkvuTkvEu01fpKdUdsaNdBlQHRVgegDtqvsDUo+Qd76pmaKlH5UThfka3jAAiAW+M8Qo3wRmK7i9qu9MxFJifc7b6IFudl5GRscBhmAJU4CvUzz5V3r8ADbC/m+NA4gAAAABJRU5ErkJggg=='

// 引导模式虚拟数据集合
const virtualData = {
  'guide-channel-all': {
    // 担当推荐的店铺组件
    data1: {
      virtual: {
        list: [
          {
            id: '-1',
            shopType: '全て',
            shopInfoList: [
              {
                shopCode: 'VC-13263',
                shopName: 'ckb_0043346'
              },
              {
                shopCode: 'VC-13301',
                shopName: 'ckb_0043156档口'
              },
              {
                shopCode: 'VC-13304',
                shopName: 'ckb_0043334档口'
              },
              {
                shopCode: 'VC-13311',
                shopName: 'ckb_0043096档口'
              },
              {
                shopCode: 'VC-13349',
                shopName: 'ckb_0038795档口'
              }
            ]
          }
        ],
        shopDetail: {
          shopCode: 'VC-13263',
          shopMainImg:
            'https://cbu01.alicdn.com/img/ibank/O1CN01jCulHA1m4hmo7jIuU_!!996564901-0-cib.jpg',
          shopName: 'ckb_0043346',
          shopMajorCateName: null,
          recommendProductList: [
            {
              productCode: 'AM-834673495',
              productSellPrice: 95,
              productSellPriceJpy: 1976,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/2020/374/850/18183058473_723926622.jpg'
            },
            {
              productCode: 'AM-1108045709',
              productSellPrice: 110,
              productSellPriceJpy: 2288,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/O1CN01jCulHA1m4hmo7jIuU_!!996564901-0-cib.jpg'
            },
            {
              productCode: 'AM-865629432',
              productSellPrice: 135,
              productSellPriceJpy: 2808,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/2017/901/310/3846013109_723926622.jpg'
            },
            {
              productCode: 'AM-1108018128',
              productSellPrice: 120,
              productSellPriceJpy: 2496,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/2018/953/379/8498973359_723926622.jpg'
            },
            {
              productCode: 'AM-1108020323',
              productSellPrice: 235,
              productSellPriceJpy: 4888,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/O1CN01qPXoBb1rqP5XHks3q_!!6000000005682-0-cib.jpg'
            },
            {
              productCode: 'AM-1108036033',
              productSellPrice: 228,
              productSellPriceJpy: 4742,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/2020/528/166/21961661825_723926622.jpg'
            },
            {
              productCode: 'AM-961390490',
              productSellPrice: 139,
              productSellPriceJpy: 2891,
              productMainImg:
                'https://cbu01.alicdn.com/img/ibank/2018/685/488/9430884586_723926622.jpg'
            }
          ]
        }
      },
      recovery: {
        list: []
      }
    },
    // 推荐的店铺组件
    data2: {
      virtual: {
        list: [
          {
            shopCode: 'VC-13263',
            shopName: 'ckb_0043346'
          },
          {
            shopCode: 'VC-13301',
            shopName: 'ckb_0043156档口'
          },
          {
            shopCode: 'VC-13304',
            shopName: 'ckb_0043334档口'
          },
          {
            shopCode: 'VC-13311',
            shopName: 'ckb_0043096档口'
          },
          {
            shopCode: 'VC-13349',
            shopName: 'ckb_0038795档口'
          }
        ],
        curId: 'VC-13263',
        curItem: {
          shopCode: 'VC-13263',
          shopMainImg: 'https://img1.vvic.com/upload/1626445231182_892111.jpg',
          shopName: 'ckb_0043346',
          shopMajorCateName: null,
          recommendProductList: [
            {
              productCode: 'VC-60f1978fc5dc010001d065d0',
              productSellPrice: 28,
              productSellPriceJpy: 547,
              productMainImg:
                'https://img1.vvic.com/upload/1626445231182_892111.jpg'
            },
            {
              productCode: 'VC-612f941d7ad80d0001a8de3f',
              productSellPrice: 55,
              productSellPriceJpy: 1074,
              productMainImg:
                'https://img1.vvic.com/upload/1630507210082_356084.jpg'
            },
            {
              productCode: 'VC-618a88cc242f640006327e4f',
              productSellPrice: 38,
              productSellPriceJpy: 742,
              productMainImg:
                'https://img1.vvic.com/upload/1636468225451_346517.jpg'
            },
            {
              productCode: 'VC-62050c3f716b4b0006bbdc91',
              productSellPrice: 55,
              productSellPriceJpy: 1074,
              productMainImg:
                'https://img1.vvic.com/upload/1644497905113_172192.jpg'
            },
            {
              productCode: 'VC-620bc17626370000064367cf',
              productSellPrice: 42,
              productSellPriceJpy: 820,
              productMainImg:
                'https://img1.vvic.com/upload/1644937465606_697022.jpg'
            },
            {
              productCode: 'VC-62235eae24b8b100065ab778',
              productSellPrice: 36,
              productSellPriceJpy: 703,
              productMainImg:
                'https://img1.vvic.com/upload/1646483962189_112697.jpg'
            },
            {
              productCode: 'VC-6235ec7c2d8d11000605504d',
              productSellPrice: 32,
              productSellPriceJpy: 625,
              productMainImg:
                'https://img1.vvic.com/upload/1647700775005_718974.jpg'
            },
            {
              productCode: 'VC-62485815d5ecdd0006bd426d',
              productSellPrice: 26,
              productSellPriceJpy: 508,
              productMainImg:
                'https://img1.vvic.com/upload/1648907469897_638288.jpg'
            },
            {
              productCode: 'VC-6249aa76c66e220007a1e36b',
              productSellPrice: 25,
              productSellPriceJpy: 488,
              productMainImg:
                'https://img1.vvic.com/upload/1648994589956_907520.jpg'
            },
            {
              productCode: 'VC-6256d01ed5ecdd0006c2ea58',
              productSellPrice: 50,
              productSellPriceJpy: 977,
              productMainImg:
                'https://img1.vvic.com/upload/1649855979951_66562.jpg'
            }
          ]
        }
      },
      recovery: {
        list: [],
        curId: '',
        curItem: null
      }
    },
    // 担当推荐的商品组件
    data3: {
      virtual: {
        list: [
          {
            productCode: 'YW-3890663',
            productSellPrice: 500,
            productSellPriceJpy: 10400,
            productTitle: '女装3',
            productMainImg:
              'https://cdnimg.chinagoods.com/jpg/2021/06/03/31b6443e138d666ed2712d0f9a9558e1.jpg'
          },
          {
            productCode: 'AM-1108020323',
            productSellPrice: 235,
            productSellPriceJpy: 4888,
            productTitle:
              '冬天中长款加厚棉衣外套2022新款冬装韩版过膝羽绒棉服冬季棉袄女',
            productMainImg:
              'https://cbu01.alicdn.com/img/ibank/O1CN01qPXoBb1rqP5XHks3q_!!6000000005682-0-cib.jpg'
          },
          {
            productCode: 'TB-620507612246',
            productSellPrice: 25.8,
            productSellPriceJpy: 536,
            productTitle:
              '2021夏季港风无袖t恤内搭工字吊带背心女韩版纯棉打底上衣外穿潮',
            productMainImg:
              'https://img.alicdn.com/imgextra/i4/4018998070/O1CN01xLYswX29U6rS1QRjY_!!0-item_pic.jpg',
            productSellQuantity: 1
          },
          {
            productCode: 'WS-12976237',
            productSellPrice: 45,
            productSellPriceJpy: 936,
            productTitle:
              '2022年春无影墙纯色字母立体钢印束脚抽绳休闲裤男卫裤K23615-P45',
            productMainImg:
              'https://imgcdn.wsy.com/v/43255/20220121/ac665cd3111cb9037489351313173998.jpg'
          },
          {
            productCode: 'YW-2961412',
            productSellPrice: 235,
            productSellPriceJpy: 4888,
            productTitle: '易创—06投光灯',
            productMainImg:
              'https://cdnimg.chinagoods.com/jpg/2020/08/16/1f4ab24a222512bb7730e404be7475f1.jpg'
          },
          {
            productCode: 'YW-2978147',
            productSellPrice: 9.9,
            productSellPriceJpy: 205,
            productTitle: '易创—07灯芯',
            productMainImg:
              'https://cdnimg.chinagoods.com/jpg/2020/08/17/5a66a423d92260704a9b5c1ea70a2b49.jpg'
          },
          {
            productCode: 'YW-2861296',
            productSellPrice: 25,
            productSellPriceJpy: 520,
            productTitle: '易创—006壁灯',
            productMainImg:
              'https://cdnimg.chinagoods.com/jpeg/2020/08/11/af8bb3ae9f0359889f8ac4dc6fcda6fa.jpeg'
          },
          {
            productCode: 'YW-3456113',
            productSellPrice: 200,
            productSellPriceJpy: 4160,
            productTitle: '女装12',
            productMainImg:
              'https://cdnimg.chinagoods.com/jpeg/2020/10/28/cbabeb4380e703c3ad5bd3f5452cd35a.jpeg'
          },
          {
            productCode: 'YW-2859998',
            productSellPrice: 25,
            productSellPriceJpy: 520,
            productTitle: '易创—001壁灯',
            productMainImg:
              'https://cdnimg.chinagoods.com/jpeg/2020/08/11/6097db6290f30198fc7813e22aa1df15.jpeg'
          },
          {
            productCode: 'AM-1083344591',
            productSellPrice: 91,
            productSellPriceJpy: 1892,
            productTitle:
              '外贸 潮流男士加厚风衣ebay 中长款加厚加的加长大衣JJ-Y22',
            productMainImg:
              'https://cbu01.alicdn.com/img/ibank/2013/713/756/1064657317_944273139.jpg'
          }
        ]
      },
      recovery: {
        list: []
      }
    }
  }
}

// plat 触发平台 b2b d2c all
// isSkip 是否可跳过
// isElFixed  是否固定定位
// element 当前指南元素id

// boxCutTop  盒子圈出距离 顶部 偏移量
// boxCutRight 盒子圈出距离 右侧 偏移量
// boxCutBottom 盒子圈出距离 底部 偏移量
// boxCutLeft 盒子圈出距离 左侧 偏移量

// popoverWidth // 弹窗的 偏移量
// description // 弹窗内容
// modalTop 弹窗距离 顶部 偏移量
// modalLeft 弹窗距离 左侧 偏移量
export const guideConfig = {
  'guide-pure-all': {
    list: [
      {
        element: '.guideDom-pure-all-1',
        isElFixed: true,
        padding: 16,
        boxCutLeft: 280,
        boxCutRight: 280,
        popover: {
          description:
            'ECサイト購入：中国主要ECサイト(1688、タオバオ、Tmall)で商品検索・買付を行います<div style="height:20px;"></div>市場仕入れ：THE CKBが提携する卸売市場から商品検索・買付を行います<div style="height:20px;"></div>MYチャンネル：THE CKBからの推薦仕入れ先、お気に入り商品などを表示します',
          position: 'bottom-left-top-right',
          popoverWidth: 600
        }
      },
      {
        element: '.guideDom-pure-all-2',
        isElFixed: true,
        padding: 16,
        boxCutLeft: 0,
        boxCutTop: 30,
        boxCutRight: 370,
        boxCutBottom: 30,
        popover: {
          description:
            '検索ECサイト、カテゴリーを指定し、商品検索キーワードを入力すれば関連商品をシステム内で検索可能です',
          position: 'bottom-left-top-left',
          popoverWidth: 600
        }
      },
      {
        element: '.guideDom-pure-all-3',
        padding: 16,
        boxCutLeft: -40,
        boxCutTop: 0,
        boxCutRight: 164,
        boxCutBottom: 0,
        modalLeft: -600,
        popover: {
          description: `“<img referrerPolicy="no-referrer" src="${icon1}" style="width:20px"/>”クリックで、指定条件を元にTHE CKBシステム内で商品検索を行います<div style="height:16px;"></div>“<img referrerPolicy="no-referrer" src="${icon2}" style="width:20px"/>”クリックで、指定条件を元に指定ECサイトで直接商品検索を行います`,
          position: 'bottom-right-top-left',
          popoverWidth: 600
        }
      },
      {
        element: '.guideDom-pure-all-4',
        isElFixed: true,
        padding: 16,
        boxCutLeft: 0,
        boxCutTop: 140,
        boxCutRight: 0,
        boxCutBottom: 130,
        modalTop: -70,
        popover: {
          description: '商品選定の便利サイトを紹介します',
          position: 'top-left-top-left',
          popoverWidth: 500
        }
      },
      {
        element: '.guideDom-pure-all-5',
        padding: 16,
        isElFixed: true,
        boxCutLeft: 0,
        boxCutTop: 0,
        boxCutRight: 0,
        boxCutBottom: 0,
        modalLeft: -600,
        popover: {
          description:
            '店舗が未作成です<br/>発注には店舗作成が必要です　店舗作成へ',
          position: 'bottom-right-top-left',
          popoverWidth: 600
        }
      },
      {
        element: '.guideDom-pure-all-6',
        padding: 16,
        isElFixed: true,
        boxCutLeft: 0,
        boxCutTop: 50,
        boxCutRight: 0,
        boxCutBottom: -30,
        modalLeft: -600,
        popover: {
          description:
            '最後、「会員情報管理」から情報編集を行ないましょう',
          position: 'bottom-right-top-left',
          popoverWidth: 600
        }
      }
    ],
    config: {
      plat: 'all',
      isSkip: false,
      nextCallback: (index) => {
        console.log(index)
        if (index === 1) {
          bus.emit('guide', { key: 'guide-pure-popover-show' })
        }
        if (index === 2) {
          bus.emit('guide', { key: 'guide-pure-popover-hide' })
        }
        if (index === 5) {
          bus.emit('showPopover')
        }
      },
      skipCallback: () => {
        bus.emit('elScrollTo', 0)
      }
    }
  },
  'guide-market-all': {
    list: [
      {
        element: '.guideDom-market-all-1',
        padding: 0,
        popover: {
          description: t(
            '点击上方切换你喜欢的品类，我们将根据该品类进行推荐。'
          ),
          position: 'bottom-left',
          popoverWidth: 574
        }
      }
    ],
    config: {
      plat: 'all',
      isSkip: false
    }
  },
  'guide-channel-all': {
    list: [
      {
        element: '.guideDom-channel-all-1',
        padding: 16,
        boxCutLeft: 0,
        boxCutTop: 0,
        boxCutRight: 0,
        boxCutBottom: 0,
        modalLeft: -600,
        popover: {
          description: t(
            '如果您有多个店铺可点击这里切换店铺，为不同的店铺采购。THE CKB也会为不同的店铺推荐不同的商品。'
          ),
          position: 'bottom-left',
          popoverWidth: 644
        }
      },
      {
        element: '.guideDom-channel-all-2',
        padding: 20,
        popover: {
          description: t(
            '你的专属担当根据你的采购习惯，为您甄选的店铺会展示在这里。'
          ),
          position: 'top-right',
          popoverWidth: 644,
          offsetX: -300
        }
      },
      {
        element: '.guideDom-channel-all-3',
        padding: 16,
        boxCutLeft: 0,
        boxCutTop: 150,
        boxCutRight: 0,
        boxCutBottom: 0,
        modalLeft: 500,
        modalTop: -80,
        popover: {
          description: t(
            '此处由系统根据你的采购习惯，为你甄选的店铺会展示在这里。'
          ),
          position: 'top-left-top-left',
          popoverWidth: 644
        }
      },
      {
        element: '.guideDom-channel-all-4',
        isElFixed: true,
        padding: 20,
        popover: {
          description: t(
            '下方为商品的推荐，会根据你的购买习惯更新商品哦！！！'
          ),
          position: 'top-right',
          popoverWidth: 644,
          offsetX: -300
        }
      }
    ],
    config: {
      plat: 'all',
      isSkip: false,
      beforeGuide: () => {},
      nextCallback: (index) => {
        if (index === 1) {
          bus.emit('guide', {
            key: 'guide-channel-ConfigRecommendShop-virtual',
            data: virtualData['guide-channel-all'].data1.virtual
          })
        }
        if (index === 2) {
          bus.emit('guide', {
            key: 'guide-channel-RecommendShop-virtual',
            data: virtualData['guide-channel-all'].data2.virtual
          })
        }
        if (index === 3) {
          bus.emit('guide', {
            key: 'guide-channel-ConfigRecommendGoods-virtual',
            data: virtualData['guide-channel-all'].data3.virtual
          })
        }
      },
      skipCallback: () => {
        bus.emit('elScrollTo', 0)
        bus.emit('guide', {
          key: 'guide-channel-ConfigRecommendShop-recovery',
          data: virtualData['guide-channel-all'].data1.recovery
        })
        bus.emit('guide', {
          key: 'guide-channel-RecommendShop-recovery',
          data: virtualData['guide-channel-all'].data2.recovery
        })
        bus.emit('guide', {
          key: 'guide-channel-ConfigRecommendGoods-recovery',
          data: virtualData['guide-channel-all'].data3.recovery
        })
      }
    }
  },
  'guide-createShop-all': {
    list: [
      {
        element: '.guideDom-createShop-all-1',
        padding: 16,
        boxCutLeft: 0,
        boxCutTop: 0,
        boxCutRight: 0,
        boxCutBottom: 0,
        modalLeft: -518,
        popover: {
          description: t(
            '你还没有店铺，快去创建一个你的店铺，用来采购你的商品。'
          ),
          position: 'bottom-left',
          popoverWidth: 600
        }
      }
    ],
    config: {
      plat: 'all',
      isSkip: false,
      nextCallback: (index) => {},
      skipCallback: () => {
        bus.emit('guide', { key: 'guide-createShop-dialog-show' })
      }
    }
  }
}
